export const LOAD_GENERALS = "LOAD_GENERALS";